<div class="screensize-monitor-container" *ngIf="showError">
  <div class="screensize-monitor">
    <townip-error-screensize></townip-error-screensize>
  </div>
</div>

